import type { ReactNode } from 'react';
import { LdsAccordion, LdsAccordionItem, LdsBox, LdsTypography } from '@lds/react';
import { LdsIconShieldCheck } from '@lds/react-icons';
import styles from './GuardrailPanel.module.scss';

interface GuardrailPanelProps {
  title: string;
  expanded: boolean;
  onChange: (expanded: boolean) => void;
  summary?: ReactNode;
  children: ReactNode;
}

export function GuardrailPanel({ title, expanded, onChange, summary, children }: GuardrailPanelProps) {
  return (
    <LdsBox className={styles.panel}>
      <LdsAccordion>
        <LdsAccordionItem open={expanded} onChange={onChange} customTitle={
          <LdsBox className={styles.title}>
            <LdsIconShieldCheck size="18" />
            <LdsTypography variant="headingXxs">{title}</LdsTypography>
            {!expanded && summary}
          </LdsBox>
        }>
          {children}
        </LdsAccordionItem>
      </LdsAccordion>
    </LdsBox>
  );
}